// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uvc9rd0 {
  border-bottom: 3px solid var(--_18w76bw2z);
  margin: 0px 90px;
}
.uvc9rd1 {
  margin: 90px 20px;
}
.uvc9rd2 {
  border-top: 2px solid var(--_18w76bw2a);
}
@media screen and (min-width: 768px) {
  .uvc9rd0 {
    margin: 0px 200px;
  }
  .uvc9rd1 {
    max-width: 85%;
    margin: 30px 100px 90px;
  }
  .uvc9rd3 {
    max-width: 220px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uCAAuC;AACzC;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".uvc9rd0 {\n  border-bottom: 3px solid var(--_18w76bw2z);\n  margin: 0px 90px;\n}\n.uvc9rd1 {\n  margin: 90px 20px;\n}\n.uvc9rd2 {\n  border-top: 2px solid var(--_18w76bw2a);\n}\n@media screen and (min-width: 768px) {\n  .uvc9rd0 {\n    margin: 0px 200px;\n  }\n  .uvc9rd1 {\n    max-width: 85%;\n    margin: 30px 100px 90px;\n  }\n  .uvc9rd3 {\n    max-width: 220px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
